<ion-app>
  <ion-router-outlet></ion-router-outlet>
</ion-app>

@if (isOverlayMounted()) {
  <!-- Covers the gap between the app booting and the first route being activated — see
       `isBootstrapping` in app.component.ts. -->
  <div class="boot-overlay"
       [class.boot-overlay--hidden]="!isOverlayVisible()"
       data-testid="boot-overlay"
       aria-hidden="true">
    <img class="boot-overlay__logo" src="/assets/svg/logo.svg" alt=""/>
    <opn-spinner [opnSize]="'large'" class="text-primary"></opn-spinner>
  </div>
}
